<a
  [routerLink]="breadcrumb.routerLink"
  class="link text-decoration-none">
  {{ breadcrumb.label }}
</a>
